export const PLAN_STARTER = [
	{ type: "feature", text: "Unlimited testimonials", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited widgets", planCardVisibilty: true },
	{ type: "feature", text: "Up to 20 testimonials per widget", planCardVisibilty: true },
	{ type: "feature", text: "Up to 20 testimonials per wall", planCardVisibilty: true },
	{ type: "feature", text: "Browser extensions", planCardVisibilty: true },
	{ type: "info", text: 'Includes "build social proof with Say About Us" badge', planCardVisibilty: true },
];

export const PLAN_STARTER_LEGACY = [
	{ type: "title", text: "Everything in Starter", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited testimonials", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited widgets", planCardVisibilty: false },
	{ type: "feature", text: "Browser extensions", planCardVisibilty: false },
	{ type: "feature", text: "No branding", planCardVisibilty: true },
	{ type: "feature", text: "Partial submissions (display only)", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited imports", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited team members", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited testimonials per widget", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited testimonials per wall", planCardVisibilty: true },
	{ type: "feature", text: "Premium widgets", planCardVisibilty: true },
	{ type: "feature", text: "Widget customization", planCardVisibilty: true },
	{ type: "feature", text: "Dynamic widgets and walls", planCardVisibilty: true },
	{ type: "info", text: 'Includes "build social proof with Say About Us" badge', planCardVisibilty: true },
];

export const PLAN_GROWTH = [
	{ type: "title", text: "Everything in Starter", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited testimonials", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited widgets", planCardVisibilty: false },
	{ type: "feature", text: "Browser extensions", planCardVisibilty: false },
	{ type: "feature", text: "No branding", planCardVisibilty: true },
	{ type: "feature", text: "Partial submissions (display only)", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited imports", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited team members", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited testimonials per widget", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited testimonials per wall", planCardVisibilty: true },
	{ type: "feature", text: "Premium widgets", planCardVisibilty: true },
	{ type: "feature", text: "Widget customization", planCardVisibilty: true },
	{ type: "feature", text: "Dynamic widgets and walls", planCardVisibilty: true },
];

export const PLAN_PLATINUM = [
	{ type: "title", text: "Everything in Growth plan", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited testimonials", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited widgets", planCardVisibilty: false },
	{ type: "feature", text: "Browser extensions", planCardVisibilty: false },
	{ type: "feature", text: "No branding", planCardVisibilty: false },
	{ type: "feature", text: "Partial submissions (display only)", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited imports", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited team members", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited testimonials per widget", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited testimonials per wall", planCardVisibilty: false },
	{ type: "feature", text: "Premium widgets", planCardVisibilty: false },
	{ type: "feature", text: "Widget customization", planCardVisibilty: false },
	{ type: "feature", text: "Dynamic widgets and walls", planCardVisibilty: false },
	{ type: "feature", text: "No monthly subscription", planCardVisibilty: true },
];

export const PLAN_GOLD = [
	{ type: "title", text: "Everything in Growth plan", planCardVisibilty: true },
	{ type: "feature", text: "Unlimited testimonials", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited widgets", planCardVisibilty: false },
	{ type: "feature", text: "Browser extensions", planCardVisibilty: false },
	{ type: "feature", text: "Partial submissions (display only)", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited imports", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited team members", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited testimonials per widget", planCardVisibilty: false },
	{ type: "feature", text: "Unlimited testimonials per wall", planCardVisibilty: false },
	{ type: "feature", text: "Premium widgets", planCardVisibilty: false },
	{ type: "feature", text: "Widget customization", planCardVisibilty: false },
	{ type: "feature", text: "Dynamic widgets and walls", planCardVisibilty: false },
	{ type: "feature", text: "No monthly subscription", planCardVisibilty: true },
	{ type: "info", text: 'Includes "build social proof with Say About Us" badge', planCardVisibilty: true },
];
